import { render } from "./Favorite-Button.vue?vue&type=template&id=724b2ee2"
import script from "./Favorite-Button.vue?vue&type=script&lang=js"
export * from "./Favorite-Button.vue?vue&type=script&lang=js"

import "./Favorite-Button.vue?vue&type=style&index=0&id=724b2ee2&lang=scss"

import exportComponent from "/home/kostas/projects_on_os/coin-data-collectors-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__